import { useQuery } from '@tanstack/react-query';
import * as api from 'util/api';

export default (runId, {
  system, status, limit, offset, enabled,
} = {}) => useQuery({
  queryKey: ['segmentation', 'changes', runId, {
    system: system ?? null,
    status: status ?? null,
    limit: limit ?? null,
    offset: offset ?? null,
  }],
  queryFn: () => api.getSegmentationRunChanges(runId, {
    ...(system ? { system } : {}),
    ...(status ? { status } : {}),
    ...(limit != null ? { limit } : {}),
    ...(offset != null ? { offset } : {}),
  }),
  enabled: enabled ?? runId != null,
  keepPreviousData: true,
});
